import * as tslib_1 from "tslib";
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { isUndefined } from 'util';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var TestGroupsService = /** @class */ (function () {
    function TestGroupsService(http) {
        this.http = http;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            })
        };
        this.formOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/x-www-form-urlencoded'
            })
        };
    }
    TestGroupsService.prototype.getDeviceGroupDetails = function (appId) {
        var endpoint = '/dashboard/getdevicegroupsdetail';
        var options = {
            headers: new HttpHeaders().set('dashboard-version', '3.0'),
            params: new HttpParams().set('app_id', appId)
        };
        return this.http.get(endpoint, tslib_1.__assign({}, this.httpOptions, options)).pipe(map(this.extractData), catchError(this.handleError('getDeviceGroupDetails')));
    };
    TestGroupsService.prototype.createDeviceGroup = function (appId, deviceGroupName) {
        var endpoint = '/dashboard/createdevicegroup';
        var toEncode = {
            'app_id': appId,
            'device_group_name': deviceGroupName
        };
        return this.http.post(endpoint, this.serializer(toEncode), this.formOptions).pipe(map(this.extractData), catchError(this.handleError('createDeviceGroup')));
    };
    TestGroupsService.prototype.deleteDeviceGroup = function (deviceGroupId, deleteDevices) {
        var endpoint = '/dashboard/deletedevicegroup';
        var toEncode = {
            'device_group_id': deviceGroupId,
            'delete_devices': deleteDevices ? 'True' : 'False'
        };
        return this.http.post(endpoint, this.serializer(toEncode), this.formOptions).pipe(map(this.extractData), catchError(this.handleError('createDeviceGroup')));
    };
    /**
     * API: create a new test user 'be'
     * @param payload data to send
     */
    TestGroupsService.prototype.createDeviceNode = function (payload) {
        var endpoint = '/dashboard/createdevice';
        var toEncode = {
            'app_id': payload.appId,
            'device_id': payload.deviceId,
            'device_name': payload.deviceName,
            'device_group_id': payload.deviceGroupId
        };
        return this.http.post(endpoint, this.serializer(toEncode), this.formOptions).pipe(map(this.extractData), catchError(this.handleError('createDeviceNode')));
    };
    /**
     * API: create a new test device 'web' 'ios' 'mobile'
     * @param payload data to send
     */
    TestGroupsService.prototype.createDeviceWebMobile = function (payload) {
        var endpoint = '/dashboard/testdevice/genurl';
        var data = {
            'app_id': payload.appId,
            'device_detail_name': payload.deviceName,
            'device_group_id': payload.deviceGroupId
        };
        if (!isUndefined(payload.webAppUrl)) {
            data.test_app_url = payload.webAppUrl;
        }
        return this.http.post(endpoint, data, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError('createDeviceWebMobile')));
    };
    /**
     * API: resend pairing URL
     * @param payload data to send
     */
    TestGroupsService.prototype.resendDevicePairingUrl = function (payload) {
        var endpoint = '/dashboard/testdevice/genurl?resend=true';
        var data = {
            'app_id': payload.appId,
            'device_detail_name': payload.deviceName,
            'device_group_id': payload.deviceGroupId
        };
        // resend web only
        if (!isUndefined(payload.webAppUrl)) {
            data.test_app_url = payload.webAppUrl;
        }
        return this.http.post(endpoint, data, this.httpOptions).pipe(map(this.extractData), catchError(this.handleError('resendDevicePairingUrl')));
    };
    /**
     * API: delete a test device
     * @param deviceId id of the device to delete
     */
    TestGroupsService.prototype.deleteDevice = function (deviceId) {
        var endpoint = '/dashboard/deletedevice';
        var toEncode = {
            device_detail_id: deviceId
        };
        return this.http.post(endpoint, this.serializer(toEncode), this.formOptions).pipe(map(this.extractData), catchError(this.handleError('deleteDevice')));
    };
    TestGroupsService.prototype.serializer = function (JSONobj) {
        var serial = [];
        for (var key in JSONobj) {
            if (JSONobj.hasOwnProperty(key)) {
                serial.push(key + '=' + JSONobj[key]);
            }
        }
        return serial.join('&');
    };
    TestGroupsService.prototype.extractData = function (res) {
        var body = res;
        return body || {};
    };
    TestGroupsService.prototype.handleError = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // TODO: send the error to remote logging infrastructure
            // TODO: better job of transforming error for user consumption
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    };
    TestGroupsService.ngInjectableDef = i0.defineInjectable({ factory: function TestGroupsService_Factory() { return new TestGroupsService(i0.inject(i1.HttpClient)); }, token: TestGroupsService, providedIn: "root" });
    return TestGroupsService;
}());
export { TestGroupsService };
